// Presentation only: preserve the official values returned by GG when linking.
export const formatGgCustomerName = (value = '') =>
  value
    .trim()
    .toLocaleLowerCase('pt-BR')
    .replace(
      /\p{L}[\p{L}\p{M}]*/gu,
      word => word.charAt(0).toLocaleUpperCase('pt-BR') + word.slice(1)
    );

export const formatGgCustomerLocation = ({ city, state }) =>
  [formatGgCustomerName(city), state?.trim().toLocaleUpperCase('pt-BR')]
    .filter(Boolean)
    .join(' - ');
